import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
 title: 'title'               the name show in submenu and breadcrumb (recommend set)
 icon: 'svg-name'             the icon show in the sidebar,
 }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: {title: '首页', icon: 'home'},
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'home'},
    }]
  },
]

export const asyncRouterMap = [
  {
    path: '/user',
    component: Layout,
    redirect: '/user/userList',
    name: 'user',
    meta: {title: '用户管理', icon: 'product'},
    children: [{
      path: 'userList',
      name: 'userList',
      component: () => import('@/views/user/user/index'),
      meta: {title: '用户列表', icon: 'product-list'}
    },
      {
        path: 'assetFlow',
        name: 'assetFlow',
        component: () => import('@/views/user/assetFlow/index'),
        meta: {title: '资产流水'},
      },
      {
        path: 'userAsset',
        name: 'userAsset',
        component: () => import('@/views/user/userAsset/index'),
        meta: {title: '用户资产'},
      },
      {
        path: 'count',
        name: 'count',
        component: () => import('@/views/user/count/index'),
        meta: {title: '数据统计'},
      },
      {
        path: 'countDetail',
        name: 'countDetail',
        component: () => import('@/views/user/count/detail'),
        meta: {title: '数据统计'},
      },
    ]
  },

  {
    path: '/notice',
    component: Layout,
    redirect: '/notice/noticeList',
    name: 'notice',
    meta: {title: '公告管理', icon: 'notice'},
    children: [{
      path: 'noticeList',
      name: 'noticeList',
      component: () => import('@/views/notice/notice/index'),
      meta: {title: '公告列表', icon: 'product-list'}
    },
      {
        path: 'banner',
        name: 'banner',
        component: () => import('@/views/notice/banner/index'),
        meta: {title: '轮播图', icon: 'product-add'}
      },

    ]
  },
  {
    path: '/finance',
    component: Layout,
    redirect: '/finance/userRecharge',
    name: 'finance',
    meta: {title: '财务管理', icon: 'sms'},
    children: [{
      path: 'userRecharge',
      name: 'userRecharge',
      component: () => import('@/views/finance/recharge/index'),
      meta: {title: '充值管理'},
    },
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/finance/order/index'),
        meta: {title: '订单列表', icon: 'order-list'}
      },
      {
        path: 'lottery',
        name: 'lottery',
        component: () => import('@/views/finance/lottery/index'),
        meta: {title: '抽奖管理'}
      },
      {
        path: 'sign',
        name: 'sign',
        component: () => import('@/views/finance/sign/index'),
        meta: {title: '签到管理'}
      },

    ]
  },
  {
    path: '/product',
    component: Layout,
    redirect: '/product',
    name: 'product',
    meta: {title: '产品管理', icon: 'product'},
    children: [{
      path: 'product',
      name: 'product',
      component: () => import('@/views/product/product/index'),
      meta: {title: '产品列表', icon: 'product'},
    },
      {
        path: 'cat',
        name: 'cat',
        component: () => import('@/views/product/cat/index'),
        meta: {title: '产品分类', icon: 'product-cate'},
      },
      {
        path: 'banner',
        name: 'banner',
        component: () => import('@/views/notice/banner/index'),
        meta: {title: '轮播图', icon: 'product-add'},
      },
    ]
  },
  {
    path: '/machine',
    component: Layout,
    redirect: '/machine/machineList',
    name: 'machine',
    meta: {title: '闸机管理', icon: 'product'},
    children: [{
      path: 'machineList',
      name: 'machineList',
      component: () => import('@/views/machine/machineRecord/index'),
      meta: {title: '通行记录', icon: 'product-list'}
    },
      {
        path: 'config',
        name: 'config',
        component: () => import('@/views/machine/config/index'),
        meta: {title: '参数配置', icon: 'product-add'}
      },

    ]
  },
  {
    path: '/competition',
    component: Layout,
    redirect: '/competition/competitionList',
    name: 'competition',
    meta: {title: '赛事管理', icon: 'product'},
    children: [{
      path: 'competitionList',
      name: 'competitionList',
      component: () => import('@/views/competition/competition/index'),
      meta: {title: '赛事列表', icon: 'product'}
    },
      {
        path: 'details',
        name: 'details',
        component: () => import('@/views/competition/competition/details'),
        meta: {title: '赛事详情', icon: 'product-add'},
      },
      {
        path: 'blindDetail',
        name: 'blindDetail',
        component: () => import('@/views/competition/competition/blindDetail'),
        meta: {title: '赛事详情', icon: 'product-add'},
      },
      {
        path: 'competitionTemplate',
        name: 'competitionTemplate',
        component: () => import('@/views/competition/template/index'),
        meta: {title: '赛事模板', icon: 'product-add'},
      },
      {
        path: 'addCompetition',
        name: 'addCompetition',
        component: () => import('@/views/competition/competition/add'),
        meta: {title: '添加赛事'},
      },
      {
        path: 'updateCompetition',
        name: 'updateCompetition',
        component: () => import('@/views/competition/competition/update'),
        meta: {title: '修改赛事'},
      },
      {
        path: 'competitionType',
        name: 'competitionType',
        component: () => import('@/views/competition/competitionType/index'),
        meta: {title: '赛事类型', icon: 'product-add'}
      },
      {
        path: 'competitionCount',
        name: 'competitionCount',
        component: () => import('@/views/competition/competition/count'),
        meta: {title: '赛事统计', icon: 'product-add'},
      },
      {
        path: 'barTable',
        name: 'barTable',
        component: () => import('@/views/competition/barTable/index'),
        meta: {title: '桌位管理', icon: 'product-add'},
      },
      {
        path: 'competitionAward',
        name: 'competitionAward',
        component: () => import('@/views/competition/award/index'),
        meta: {title: '奖励管理', icon: 'product-add'}
      },
      {
        path: 'competitionGiveAward',
        name: 'competitionGiveAward',
        component: () => import('@/views/competition/award/giveAward'),
        meta: {title: '奖励确认', icon: 'product-add'},
      },
      {
        path: 'tableBoard',
        name: 'tableBoard',
        component: () => import('@/views/competition/tableBoard/index'),
        meta: {title: '牌桌管理', icon: 'product-add'},
      },
      {
        path: 'screen',
        name: 'screen',
        component: () => import('@/views/competition/screen/index'),
        meta: {title: '投屏配置', icon: 'product-add'},
      },

    ]
  },
  {
    path: '/coupon',
    component: Layout,
    redirect: '/coupon/couponList',
    name: 'coupon',
    meta: {title: '卡券管理', icon: 'product'},
    children: [{
      path: 'couponList',
      name: 'couponList',
      component: () => import('@/views/coupon/coupon/index'),
      meta: {title: '卡券列表', icon: 'product-list'}
    },
      {
        path: 'barCoupon',
        name: 'barCoupon',
        component: () => import('@/views/coupon/barCoupon/index'),
        meta: {title: '酒券管理', icon: 'product-list'}
      },
      {
        path: 'couponType',
        name: 'couponType',
        component: () => import('@/views/coupon/couponType/index'),
        meta: {title: '卡券类型', icon: 'product-add'}
      },
      {
        path: 'physicalCardList',
        name: 'physicalCardList',
        component: () => import('@/views/coupon/physicalCard/index'),
        meta: {title: '实体卡', icon: 'product-list'}
      },
      {
        path: 'package',
        name: 'package',
        component: () => import('@/views/coupon/package/index'),
        meta: {title: '套餐配置', icon: 'product-add'}
      },
    ]
  },

  {
    path: '/sys',
    component: Layout,
    redirect: '/sys/admin',
    name: 'sys',
    meta: {title: '权限', icon: 'sys'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/sys/admin/index'),
        meta: {title: '用户列表', icon: 'sys-admin'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/sys/role/index'),
        meta: {title: '角色列表', icon: 'sys-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/sys/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/sys/menu/index'),
        meta: {title: '菜单列表', icon: 'sys-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/sys/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/sys/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'merchant',
        name: 'merchant',
        component: () => import('@/views/sys/menu/index'),
        meta: {title: '商户管理', icon: 'product-list'}
      },
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js